module.exports = __webpack_public_path__ + "img/noimage.faad8b46.png";